module.exports = __webpack_public_path__ + "img/certificate2-01.777eb84d.png";